import { AsyncDashboardComponent, AsyncDashboardAllComponent } from 'Components/AsyncComponent/AsyncComponent';
import React from 'react';
import { Route, Routes } from 'react-router-dom';

const Dashboard = () => {
  return (
    <div className="content-wrapper">
      <Routes>
        <Route path="" element={<AsyncDashboardAllComponent />} />
        <Route path="field" element={<AsyncDashboardComponent />} />
      </Routes>
    </div>
  );
};

export default Dashboard;
